import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '../lib/api';
import { useAuth } from './AuthContext';

const LicenseContext = createContext({ license: null, reload: () => {} });

export const useLicense = () => useContext(LicenseContext);

export const LicenseProvider = ({ children }) => {
  const { user } = useAuth();
  const [license, setLicense] = useState(null);
  const reload = useCallback(async () => {
    if (!user) return;
    try { const r = await api.getMyLicense(); setLicense(r.data); } catch { setLicense(null); }
  }, [user]);
  useEffect(() => { reload(); }, [reload]);
  return <LicenseContext.Provider value={{ license, reload }}>{children}</LicenseContext.Provider>;
};
